import React, {Component} from "react";
import App from "../../App";
import Pagination from "react-js-pagination";
import { withRouter } from "react-router-dom";
import "../../assets/scss/order-list.scss";
import { ToastsContainer, ToastsStore } from "react-toasts";
import { getPaginatedList } from "../../services/baseServices";
import Loader from 'react-loader';
import { Button } from "react-bootstrap";

class List extends Component {
    constructor() {
        super();
        this.state = {
            bankList: [],
            isLoading: true,
            activePage: 1,
            per_page: 15,
            page: 1,
            temp_params: {}
        };
    }

    getQueryParams = () => {
        let params = {per_page: this.state.per_page, page: this.state.page};
        return params;
    }

    getPaginatedBankList = (params) => {
        this.setState({...this.state, isLoading: true});
        getPaginatedList("bank_accounts/list", params)
            .then(res => {
                this.setState({
                    bankList: res.data,
                    isLoading: false,
                    per_page: res.headers['x-per-page'],
                    total_data: res.headers['x-total'],
                }, () => {
                });
            })
            .catch(errMsg => {
                this.setState({...this.state, isLoading: false});
                console.log('Error Message: ', errMsg)
            })
    }

    componentDidMount() {
        this.getPaginatedBankList(this.getQueryParams());
    }

    handlePageChange = (pageNumber) => {
        this.setState({page: pageNumber, activePage: pageNumber}, () => {
            this.getPaginatedBankList(this.getQueryParams());
        });
    }

    handleOnSearch = (e) => {
        e.preventDefault();
        const tempParam = this.state.temp_params;
        console.log(tempParam)
        this.setState({...this.state, page: 1, query_params: tempParam}, () => {
            this.getPaginatedBankList(this.state.temp_params);
        });
    }

    handleOnFieldChange = (e) => {
        const queryData = {...this.state.temp_params};
        queryData[e.target.name] = e.target.value;
        this.setState({temp_params: queryData}, () => {
        });
    }

    render() {
        return (
            <App layout="">
                <div className="main-content">
                    <div className="page-header">
                        <h2 className="page-title">Bank Account List</h2>
                    </div>
                    <form className="form-inline mb-3">
                        <div className="form-group mr-3">
                            <label htmlFor="account_type" className="sr-only">
                                Type
                            </label>
                            <select
                                id="account_type"
                                name="account_type"
                                className="form-control form-control-sm"
                                onChange={(e) => {
                                    this.handleOnFieldChange(e);
                                }}
                            >
                            <option value="">--Select Type--</option>
                            <option value={"finance"}> Finance </option>
                            <option value={"supplier"}> Supplier </option>
                            <option value={"distributor"}> Distributor </option>
                            </select>
                        </div>
                        <Button
                            size="sm"
                            type={`submit`}
                            onClick={this.handleOnSearch}
                            variant="primary"
                        >
                            Filter
                        </Button>
                    </form>
                    <Loader loaded={!this.state.isLoading}>
                        <div className="card-block">
                            <div className="block-body">
                                <table className="order-table table table-striped">
                                    <thead>
                                    <tr>
                                        <th style={{width: "20px"}}>#</th>
                                        <th>Bank Title</th>
                                        <th>Account Name</th>
                                        <th>Bank Name</th>
                                        <th>Branch Name</th>
                                        <th>Account Type</th>
                                        <th>For Whom</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {this.state.bankList?.length > 0 ? (
                                        this.state.bankList.map((bank, index) => {
                                            return (
                                                <tr key={index}>
                                                    <td>
                                                        {(this.state.page - 1) * this.state.per_page +
                                                        index +
                                                        1}
                                                    </td>
                                                    <td>
                                                        <div className="order-item">
                                                            {bank.title}
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="order-item">
                                                            {bank.account_name}
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="order-item">
                                                            {bank.bank_name}
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="order-item">
                                                            {bank.branch_name}
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="order-item">
                                                            {bank.account_type}
                                                        </div>
                                                    </td>
                                                    <td>
                                                        {bank.account_holder}
                                                    </td>
                                                </tr>
                                            );
                                        })
                                    ) : (
                                        <tr>
                                            <td colSpan={6} className="text-center">
                                                {" "}
                                                <h5>No Order Found</h5>
                                            </td>
                                        </tr>
                                    )}
                                    </tbody>
                                </table>
                            </div>
                            <div className="mt-3">
                                <Pagination
                                    itemClass="page-item"
                                    linkClass="page-link"
                                    activePage={this.state.activePage}
                                    itemsCountPerPage={this.state.per_page}
                                    totalItemsCount={this.state.total_data}
                                    pageRangeDisplayed={10}
                                    onChange={this.handlePageChange.bind(this)}
                                />
                            </div>
                        </div>

                    </Loader>
                </div>
                <ToastsContainer store={ToastsStore}/>
            </App>
        );
    }
}

export default withRouter(List);
